import fireErrorAnalytics from '@atlassian/error-handling/fire-error-analytics';

const XFLOW_BASE_URL = '/gateway/api/xflow';

/**
 * Sends a request trial request to the xflow endpoint
 * Only calls the endpoint if the user is not an admin
 *
 * @param cloudId - Cloud ID for the request
 * @param edition - Edition string for the request
 * @returns Promise that resolves when the request is complete
 */

type SendRequestTrialResult = {
	approvalUrl: string;
	status: string;
};

export const sendRequestTrial = async (
	cloudId: string,
	edition: 'free' | 'standard' | 'premium',
	requestTrialCommentText: string,
): Promise<SendRequestTrialResult> => {
	try {
		const cloudInstance = window.location.origin;
		const response = await fetch(
			`${XFLOW_BASE_URL}/${encodeURIComponent(cloudId)}/send-request-trial/teamwork-collection`,
			{
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				credentials: 'include',
				body: JSON.stringify({
					cloud_instance: cloudInstance,
					requested_access_comment_text: requestTrialCommentText,
					is_cross_sell: false,
					edition: edition || '',
					migration_source_uuid: '',
				}),
			},
		);

		if (!response.ok) {
			throw new Error(`HTTP error! status: ${response.status}`);
		}
		return response.json() as Promise<SendRequestTrialResult>;
	} catch (error) {
		fireErrorAnalytics({
			error: error as Error,
			meta: {
				id: 'send-request-trial',
				packageName: '@atlassian/twc-xflow-modal',
				teamName: 'starburst',
			},
			attributes: {
				cloudId,
			},
		});
		throw error;
	}
};
